import { injectCpmsBoCustomerApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-customer.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoCustomerApi = injectCpmsBoCustomerApi(baseApi);

export const {
  useCpmsBoCreateCustomerMutation,
  useCpmsBoGetCustomerQuery,
  useCpmsBoGetCustomersPaginatedQuery,
  useCpmsBoUpdateCustomerMutation,
  useCpmsBoSetCustomerChargePointSubscriptionMutation,
} = cpmsBoCustomerApi;
